import heroImgEn1 from "../../src/assets/HomeSection/heroImgEn1.png";
import heroImgEn2 from "../../src/assets/HomeSection/heroImgEn2.png";

import heroImgSi1 from "../../src/assets/HomeSection/heroImgSi1.png";
import heroImgSi2 from "../../src/assets/HomeSection/heroImgSi2.png";

import heroImgTa1 from "../../src/assets/HomeSection/heroImgTa1.png";
import heroImgTa2 from "../../src/assets/HomeSection/heroImgTa2.png";

export const englishData = [
  {
    regBtn: "Get Free Start",
    titleMain: "Your Driving License Exam",
    titleHigh: "Pass",
    titleEnd: "Easily",
    subTitle:
      "Get all the questions papers and video lessons you need now in one place.!",
    slides: [
      {
        image: heroImgEn1,
        link: "/sri-lanka-driving-license-exam-papers",
        alt: "hire Personal Driving Instructor online in Sri Lanka",
      },
      {
        image: heroImgEn2,
        link: "/driving-license-video-guide",
        alt: "get Driving License with online Instructor in Sri Lanka",
      },
    ],
    StepsTitle: "Start your learning journey today",
    LessonsTitle: "Our Lessons",
    LessonsSubTitle: "Step-by-Step Driving Lessons",
    LessonsDescription:
      "We provide step-by-step driving lessons designed to help learners build confidence and master safe driving skills. From theory tutorials and road signs to practical guidance, our lessons cover everything you need to successfully pass your driving license exam.",
    LessonsBtn: "Start Learning",
    PapersTitle: "Papers",
    PapersSubTitle: "Mock Tests for Driving license exam Success!",
    PapersSubTitle2:
      "Practice with mock tests and ace your  driving exam effortlessly! Stay confident and ready with realistic  questions and instant feedback. Your journey to driving success starts  here!",
    paperNo1: "Paper 01",
    paperNo2: "Paper 02",
    paperNo3: "Paper 03",
    paperNo4: "Paper 04",
    PapersDes:
      "It includes the question papers, video lessons and accurate instructions needed to successfully pass the driving license exam. We are committed to providing you with any support you need from the beginning of your studies to the final moment of obtaining your license.",
    HandbookTitle: "Driving Handbook",
    HandbookSubTitle: "Driving Handbook Guide",
    HandbookSubTitle2:
      "Our Driving Handbook is your complete study companion for the Sri Lanka Driving License Exam.",
    SubTopic1:
      "Road Rules – Learn essential traffic laws and safe driving practices.",
    SubTopic2:
      "Traffic Signs & Symbols – Understand every sign you’ll encounter on the road.",
    SubTopic3:
      "Driving Etiquette – Build confidence with correct driving manners and safety tips.",
    SubTopic4:
      "Exam Preparation – Covers all topics tested in the theory exam.",
    HandBookBtn: "Read Now ",
    ServiceTitle: "Our Services",
    ServiceSubTitle: "Register Your Driving School With Us",
    ServiceSubTitle2:
      "Expand your reach by partnering with our platform. Driving schools can easily register and showcase their services to thousands of learners preparing for their driving license exams. Gain visibility, attract more students, and grow your school with us.",
    ServicSubTopic1:
      "Easy Registration – Sign up your driving school in just a few steps.",
    ServicSubTopic2:
      "Connect With Learners – Reach students actively preparing for their driving license exams.",
    ServicSubTopic3:
      "Boost Online Visibility – Get discovered by a wider audience online.",
    ServicSubTopic4:
      "Grow Your School – Attract more enrollments and expand your business.",
    ServiceBtn: "Start Join as a Driving School",
    description:
      "Prepare for your driving test with expert resources and mock exams designed for success.",
    modelTitle: "Change in Question Paper Format",
    allqueButton: "I want to Answer all questions once",
    oneByoneButton: "I want to Answer questions one by one",
  },
];

export const sinhalaData = [
  {
    regBtn: "නොමිලේ පටන්ගන්න ක්ලික් කරන්න...",
    titleMain: "රියදුරු බලපත්‍ර විභාගය",
    titleHigh: "පහසුවෙන්",
    titleEnd: "සමත්වෙන්න",
    subTitle:
      "ඔබට අවශ්‍ය සියලුම ප්‍රශ්න පත්‍ර හා වීඩියෝ පාඩම් දැන් එකම තැනකින්.!",
    slides: [
      {
        image: heroImgSi1,
        link: "/sri-lanka-driving-license-exam-papers",
        alt: "ශ්‍රී ලංකා රියදුරු බලපත්‍ර විභාග ප්‍රශ්න පත්‍ර",
      },
      {
        image: heroImgSi2,
        link: "/driving-license-video-guide",
        alt: "රියදුරු බලපත්‍ර වීඩියෝ මාර්ගෝපදේශය",
      },
    ],
    StepsTitle: "රියදුරු බලපත්‍රය ලබා ගැනීමේ ක්‍රියාවලිය",
    LessonsTitle: "වීඩ්යෝ පාඩම් මාලාව",
    LessonsSubTitle: "රියදුරු පුහුණුවට දැනගත යුතු කරුණු",
    LessonsDescription:
      "අපි ලබා දෙන පියවරෙන් පියවර රියදුරු පුහුණු පාඩම්, අධ්‍යයන ශිෂ්‍යයන්ට විශ්වාසය වර්ධනය කරමින්, ආරක්ෂිත රියදුරු කුසලතා මනා ලෙස හැසිරවිය හැකි ලෙස නිර්මාණය කර ඇත. සංකල්ප මාර්ගෝපදේශ, මාර්ග සංඥා සහ ප්‍රායෝගික උපදෙස් ඇතුළු අපේ පාඩම්, ඔබේ රියදුරු විභාගය සාර්ථකව දිනීමට අවශ්‍ය සියල්ල ආවරණය කරයි.",
    LessonsBtn: "ඉගෙනීම ආරම්භ කරන්න",
    PapersTitle: "විභාග ප්‍රශ්න පත්‍ර",
    PapersSubTitle: "විභාගයට සූදානම් වීමට ප්‍රශ්න පත්‍ර හා ආදර්ශ ප්‍රශ්න පත්‍ර",
    PapersSubTitle2:
      "ඔබේ රියදුරු විභාගය ජයගන්න පහසුම මාර්ගය මෙන්න! පසුගිය ප්‍රශ්න පත්‍ර, සහ ආදර්ශ ප්‍රශ්න පත්‍ර සමඟ ඔබට අවශ්‍ය සියලු දැනුම ලබා දෙයි. විශ්වාසයෙන් සහ සූදානමින් විභාගයට යන්න!",
    paperNo1: "ප්‍රශ්න පත්‍ර අංක 01",
    paperNo2: "ප්‍රශ්න පත්‍ර අංක 02",
    paperNo3: "ප්‍රශ්න පත්‍ර අංක 03",
    paperNo4: "ප්‍රශ්න පත්‍ර අංක 04",
    PapersDes:
      "රියදුරු බලපත්‍ර විභාගයට සාර්ථකව මුහුණ දීමට අවශ්‍ය ප්‍රශ්න පත්‍ර, වීඩියෝ පාඩම් සහ නිවැරදි උපදෙස් මාලාවන් මෙහි ඇතුළත් වේ. ඉගෙනීමේ ආරම්භයේ සිට බලපත්‍රය ලබාගන්නා අවසාන මොහොත දක්වා ඔබට අවශ්‍ය ඕනෑම සහයෝගයක් ලබා දීමට අප කැපවී සිටින්නෙමු.",
    HandbookTitle: "රියදුරු අත්පොත",
    HandbookSubTitle: "රියදුරු අත්පොත මාර්ගෝපදේශය",
    HandbookSubTitle2:
      "ශ්‍රී ලංකා රියදුරු විභාගයට අවශ්‍යම දැනුම සහ මාර්ගෝපදේශය එකට එක්කරුණු ඔබේ විශ්වාසනීය අධ්‍යයන සගයායි අපගේ රියදුරු අත්පොත",
    SubTopic1:
      "මාර්ග නීති – අත්‍යවශ්‍ය මාර්ග නීති හා ආරක්ෂිත රිය පැදවීමේ ක්‍රියාපටිපාටීය ඉගෙනගන්න.",
    SubTopic2:
      "මාර්ග සංඥා හා සංකේත – මාර්ගයේ ඔබ මුහුණ දෙන සියලුම සංඥා හඳුනාගන්න.",
    SubTopic3:
      "රියදුරු ආචාර ධර්ම - – නිවැරදි රියදුරු ආචාර ධර්ම සහ ආරක්ෂිත උපදෙස් සමඟ විශ්වාසය ගොඩනගන්න.",
    SubTopic4: "විභාග සූදානම – විභාගයේ පරීක්ෂා වන සියලුම කරුණු ආවරණය කරයි.",
    HandBookBtn: "දැන් කියවන්න ",
    ServiceTitle: "අපගේ සේවාවන්",
    ServiceSubTitle: "ඔබගේ රියදුරු පාසල අප සමඟ ලියාපදිංචි කරන්න",
    ServiceSubTitle2:
      "අපගේ වෙබ් අඩවිය සමඟ එකතු වී ඔබේ රියදුරු  පාසල වැඩි දෙනෙකුට හඳුන්වා දෙන්න. පහසුවෙන් ලියාපදිංචි වී, විභාගයට සූදානම් වන ශිෂ්‍යයන් වෙත ඔබේ සේවා ප්‍රදර්ශනය කරන්න. වැඩි ශිෂ්‍යයන් ආකර්ෂණය කර, ඔබේ පාසල අප සමඟ වර්ධනය කරන්න!",
    ServicSubTopic1:
      "පහසු ලියාපදිංචිය – ඔබේ රියදුරු පාසල කිහිප පියවරකින් ලියාපදිංචි කරන්න",
    ServicSubTopic2:
      "ශිෂ්‍යයන් සමඟ සම්බන්ධ වන්න – රියදුරු විභාගයට සූදානම් වන ශිෂ්‍යයන් වෙත ළඟා වන්න.",
    ServicSubTopic3:
      "ඔන්ලයින් දැක්ම වැඩි කරන්න – පුළුල් පිරිසකට ඔබේ පාසල හඳුන්වා දෙන්න",
    ServicSubTopic4:
      "ඔබේ පාසල වර්ධනය කරන්න – වැඩි ලියාපදිංචි ශිෂ්‍යයන් ආකර්ෂණය කර ව්‍යාපාරය වැඩි දියුණු කරගන්න.",
    ServiceBtn: "සම්බන්ද වීමට ක්ලික් කරන්න",
    description:
      "විභාගයට සාර්ථකව මුහුණදීමට විශේෂඥ පුහුණුව, උපදෙස්  සහ පෙර පුහුණු ප්‍රශ්න පත්‍ර.",
    modelTitle: "ප්‍රශ්න පත්‍ර ආකාරය වෙනස් කිරීම",
    allqueButton: "සියලුම ප්‍රශ්න වලට එකවර පිළිතුරු දීමට",
    oneByoneButton: "ප්‍රශ්න වලට එකින් එක පිළිතුරු දීමට",
  },
];

export const tamilData = [
  {
    regBtn: "இலவசமாக தொடங்க கிளிக் செய்யவும்...",
    titleMain: "உங்கள் ஓட்டுநர்",
    titleHigh: "கற்றல்",
    titleEnd: "திறன்களை மேம்படுத்துங்கள்",
    subTitle: "விரைவாகவும் நம்பிக்கையுடனும் கற்றுக்கொள்ளுங்கள்!",
    slides: [
      {
        image: heroImgTa1,
        link: "/sri-lanka-driving-license-exam-papers",
        alt: "இலங்கை ஓட்டுநர் உரிமம் தேர்வு வினாத்தாள்கள்",
      },
      {
        image: heroImgTa2,
        link: "/driving-license-video-guide",
        alt: "ஓட்டுநர் உரிமம் வீடியோ வழிகாட்டி",
      },
    ],
    StepsTitle: "உங்கள் ஓட்டுநர் பயணத்தை இன்று தொடங்குங்கள்",
    LessonsTitle: "எங்கள் பாடங்கள்",
    LessonsSubTitle: "படிப்படியாக ஓட்டுநர் பாடங்கள்",
    LessonsDescription:
      "நாங்கள் வழங்கும் படிப்படியாக ஓட்டுநர் பயிற்சி பாடங்கள், கற்றலாளர்களுக்கு நம்பிக்கை வளர்க்கவும், பாதுகாப்பான ஓட்டுநர் திறன்களை நன்கு கையாளவும் உதவுவதற்காக வடிவமைக்கப்பட்டுள்ளன. கோட்பாட்டு பாடங்கள், சாலை குறியீடுகள் மற்றும் நடைமுறை வழிகாட்டுதல்களிலிருந்து, எங்கள் பாடங்கள் உங்கள் ஓட்டுநர் உரிமம் தேர்வை வெற்றிகரமாக கடக்க தேவையான அனைத்தையும் உள்ளடக்கியவை.",
    LessonsBtn: "கற்றல் தொடங்கு",
    PapersTitle: "காகிதங்கள்",
    PapersSubTitle: "ஓட்டுநர் உரிமம் தேர்வில் வெற்றிக்கான மொக் டெஸ்ட்கள்!",
    PapersSubTitle2:
      "மொக் டெஸ்ட்களுடன் பயிற்சி செய்து உங்கள் ஓட்டுநர் தேர்வை எளிதாக வெற்றிகரமாக்குங்கள்! உண்மையான கேள்விகள் மற்றும் உடனடி பின்னூட்டத்துடன் நம்பிக்கையுடனும் தயாராகவும் இருங்கள். ஓட்டுநர் வெற்றிக்கான உங்கள் பயணம் இங்கே தொடங்குகிறது!",
    paperNo1: "காகிதம் 01",
    paperNo2: "காகிதம் 02",
    paperNo3: "காகிதம் 03",
    paperNo4: "காகிதம் 04",
    PapersDes: "ஓட்டுநர் உரிமத் தேர்வில் வெற்றிகரமாக தேர்ச்சி பெற தேவையான வினாத்தாள்கள், வீடியோ பாடங்கள் மற்றும் துல்லியமான வழிமுறைகள் இதில் அடங்கும். உங்கள் படிப்பின் தொடக்கத்திலிருந்து உரிமம் பெறும் இறுதி தருணம் வரை உங்களுக்குத் தேவையான எந்தவொரு ஆதரவையும் வழங்க நாங்கள் உறுதிபூண்டுள்ளோம்.",
    HandbookTitle: "ஓட்டுநர் கையேடு",
    HandbookSubTitle: "ஓட்டுநர் கையேடு வழிகாட்டி",
    HandbookSubTitle2:
      "எங்கள் ஓட்டுநர் கையேடு உங்கள் முழுமையான படிப்பு தோழராகும், இது இலங்கை ஓட்டுநர் உரிமம் தேர்வுக்கான அனைத்து தேவையான அறிவையும் வழிகாட்டுதல்களையும் வழங்குகிறது.",
    SubTopic1:
      "சாலை விதிகள் – முக்கிய போக்குவரத்து சட்டங்கள் மற்றும் பாதுகாப்பான ஓட்டுநர் நடைமுறைகளை கற்றுக்கொள்ளுங்கள்.",
    SubTopic2:
      "போக்குவரத்து குறியீடுகள் மற்றும் சின்னங்கள் – சாலையில் நீங்கள் சந்திக்கும் ஒவ்வொரு சின்னத்தையும் புரிந்துகொள்ளுங்கள்.",
    SubTopic3:
      "ஓட்டுநர் மரியாதை – சரியான ஓட்டுநர் மரியாதைகள் மற்றும் பாதுகாப்பு குறிப்புகளுடன் நம்பிக்கையை கட்டியெழுப்புங்கள்.",
    SubTopic4:
      "தேர்வு தயாரிப்பு – கோட்பாட்டு தேர்வில் பரிசோதிக்கப்படும் அனைத்து தலைப்புகளையும் உள்ளடக்கியது.",
    HandBookBtn: "இப்போது படிக்கவும் ",
    ServiceTitle: "எங்கள் சேவைகள்",
    ServiceSubTitle: "உங்கள் ஓட்டுநர் பள்ளியை எங்களுடன் பதிவு செய்யுங்கள்",
    ServiceSubTitle2:
      "எங்கள் தளத்துடன் கூட்டாளியாக உங்கள் அடையலை விரிவுபடுத்துங்கள். ஓட்டுநர் பள்ளிகள் எளிதாக பதிவு செய்து, ஓட்டுநர் உரிமம் தேர்வுக்காக தயாராகும் ஆயிரக்கணக்கான கற்றலாளர்களுக்கு தங்கள் சேவைகளை காட்சிப்படுத்தலாம். காட்சி பெறுங்கள், மேலும் மாணவர்களை ஈர்க்கவும், எங்களுடன் உங்கள் பள்ளியை வளர்க்கவும்.",
    ServicSubTopic1:
      "எளிய பதிவு – சில படிகளிலேயே உங்கள் ஓட்டுநர் பள்ளியை பதிவு செய்யுங்கள்.",
    ServicSubTopic2:
      "கற்றலாளர்களுடன் இணையுங்கள் – ஓட்டுநர் உரிமம் தேர்வுக்காக தயாராகும் மாணவர்களை அடையுங்கள்.",
    ServicSubTopic3:
      "ஆன்லைன் காட்சி மேம்படுத்துங்கள் – ஒரு பரபரப்பான பார்வையாளர்களால் கண்டுபிடிக்கப்படுங்கள்.",
    ServicSubTopic4:
      "உங்கள் பள்ளியை வளர்க்கவும் – மேலும் மாணவர்களை ஈர்க்கவும் மற்றும் உங்கள் வணிகத்தை விரிவுபடுத்தவும்.",
    ServiceBtn: "ஓட்டுநர் பள்ளியாக சேர தொடங்கு",
    description:
      "நிபுணத்துவ ஆதாரங்கள் மற்றும் வெற்றிக்காக வடிவமைக்கப்பட்ட போலித் தேர்வுகளுடன் உங்கள் ஓட்டுநர் சோதனைக்குத் தயாராகுங்கள்.",
    modelTitle: "வினாத்தாள் வடிவத்தில் மாற்றம்",
    allqueButton: "அனைத்து கேள்விகளுக்கும் ஒரே நேரத்தில் பதிலளிக்க",
    oneByoneButton: "கேள்விகளுக்கு ஒவ்வொன்றாகப் பதில் சொல்ல வேண்டும்",
  },
];
